import {
  // Alert,
  Group,
  PasswordInput,
  Space,
  Stack,
  TextInput,
} from "@mantine/core";
import validator from "validator";
import {
  IconBrandTelegram,
  // IconInfoCircle,
  IconLink,
  IconMail,
  IconPhotoPlus,
} from "@tabler/icons-react";
import { useIsDesktop, useStyles } from "@/styles/useStyles";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Firebase } from "@/firebase/firebase";
import { useNavigate, useParams } from "react-router-dom";
import {
  useActiveUserPartner,
  useIsLoggedIn,
  // useIsRestrictedApp,
  usePartnerBySlug,
  usePartnerFromUrl,
  usePartners,
} from "@/store/selectors";
import { Link } from "@/components/ui/Link";
import { Button } from "@/components/ui/Button";
import { Image } from "@/components/ui/Image";
import { checkIfMatchesEmailFormat } from "@/lib/helpers";
import { Analytics } from "@/services/Analytics";
import { Title } from "@/components/ui/Title";
import { Text } from "@/components/ui/Text";
import { GoogleAuthButton } from "@/components/auth/GoogleAuthButton";
import { PartnerSelector } from "@/components/PartnerSelector";
import { TermsAndConditions } from "@/components/TermsAndConditions";
import { Navigation } from "@/services/Navigation";
// import { useActivePlaylistId } from "@/store/selectors/playlistSelectors";
import { Playlist } from "@/components/playlists/Playlist";
import { useStore } from "@/store";
import {
  useIsDemoApp,
  useIsPartnerApp,
  // useIsPartnerApp,
} from "@/store/selectors/featureSelectors";
import { useRequirePartnerEmailValidation } from "@/store/selectors/featureSelectors";
import { useIsAssignmentPage } from "@/store/selectors/assignmentSelectors";

export const Login = (props: {
  isPartnerSelection?: boolean;
  isGeneralLogin?: boolean;
}) => {
  const { isGeneralLogin } = props;
  const isDesktop = useIsDesktop();
  const { theme } = useStyles();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [isPasswordLogin, setIsPasswordLogin] = useState(true);
  const [isPasswordResetView, setIsPasswordResetView] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const { partnerSlug } = useParams();
  const activeUserPartner = useActiveUserPartner();
  const partnerFromUrl = usePartnerFromUrl();
  const partner = usePartnerBySlug(
    partnerSlug || partnerFromUrl?.slug || activeUserPartner?.slug,
  );
  const isAssignmentPage = useIsAssignmentPage();
  // const isRestrictedApp = useIsRestrictedApp();
  const partners = usePartners();
  // const activePlaylistId = useActivePlaylistId();
  // const isPartnerApp = useIsPartnerApp();
  const requirePartnerEmailValidation = useRequirePartnerEmailValidation();
  const isDemoApp = useIsDemoApp();
  const isPartnerApp = useIsPartnerApp();

  const isPartnerSelection =
    (props.isPartnerSelection || (!partner && !isGeneralLogin)) && !isDemoApp;

  // const isLoggingInDuringPlaylist = useStore(
  //   (state) => state.playlists.isLoggingInDuringPlaylist,
  // );
  const setShowMainNavbar = useStore((state) => state.setShowMainNavbar);
  const showPlaylistHeader = !partner && !isDemoApp && !isPartnerApp;
  // (activePlaylistId || isLoggingInDuringPlaylist) && !partner;

  const navigate = useNavigate();
  const isLoggedIn = useIsLoggedIn();

  useEffect(() => {
    if (isLoggedIn && !isDemoApp) {
      navigate("/");
    }
  }, [navigate, isLoggedIn, isDemoApp]);

  // useEffect(() => {
  //   if (isPartnerApp && !isPartnerSelection && !isGeneralLogin && !partner) {
  //     navigate("/login/partners");
  //   }
  // }, [navigate, isPartnerApp, isPartnerSelection, isGeneralLogin, partner]);

  useEffect(() => {
    if (partner?.hideFromLogin) {
      navigate("/login/partners");
    }
  }, [partner, navigate]);

  useEffect(() => {
    setShowMainNavbar(true);
  }, [partner, setShowMainNavbar]);

  useEffect(() => {
    if (partnerSlug === "arizona-eller") {
      const arizonaEllerPartner = partners.find((partner) =>
        partner.slug?.includes("eller"),
      );
      if (arizonaEllerPartner) {
        Navigation.navigate(`/login/${arizonaEllerPartner?.slug}`);
      }
    }

    if (partnerSlug === "smu") {
      const southernMethodistUniversityPartner = partners.find((partner) =>
        partner.slug?.includes("southern-methodist-university"),
      );
      if (southernMethodistUniversityPartner) {
        Navigation.navigate(`/login/${southernMethodistUniversityPartner?.slug}`);
      }
    }
  }, [partnerSlug, partners]);

  // useEffect(() => {
  //   if (isPartnerApp && isGeneralLogin && config.isProductionClient) {
  //     navigate("/login/partners");
  //   }
  // }, [isPartnerApp, isGeneralLogin, navigate]);

  const handleError = useCallback(
    (errorMessage: string) => {
      console.log("handleError", errorMessage);
      setEmailError(errorMessage);
      Analytics.invalidEmail({
        inputValue: email,
        error: errorMessage,
      });
    },
    [email],
  );

  const handleSubmit = useCallback(async () => {
    console.log("handleSubmit", { partner, email, isPasswordLogin });
    if (isDemoApp && !email.includes("demo")) {
      handleError("Login is disabled in demo mode");
      return;
    }

    if (!email) {
      handleError("Please enter your email");
      return;
    }

    if (
      isPartnerApp &&
      partner?.partnerEmailFormat &&
      !checkIfMatchesEmailFormat({
        email,
        emailFormat: partner.partnerEmailFormat,
      })
    ) {
      handleError(`Please enter your work email for ${partner.title}`);
      return;
    }

    if (
      requirePartnerEmailValidation &&
      partner?.emailFormat &&
      !(isPartnerApp && partner?.partnerEmailFormat) &&
      !checkIfMatchesEmailFormat({ email, emailFormat: partner.emailFormat })
    ) {
      handleError(`Please enter your email for ${partner.title}`);
      return;
    }

    // if (
    //   requirePartnerEmailValidation &&
    //   partner?.partnerEmailFormat &&
    //   !checkIfMatchesEmailFormat({
    //     email,
    //     emailFormat: partner.partnerEmailFormat,
    //   })
    // ) {
    //   handleError(`Please enter your work email for ${partner.title}`);
    //   return;
    // }

    if (!validator.isEmail(email)) {
      handleError("Please enter a valid email");
      return;
    }

    if (isPasswordLogin && !password) {
      setPasswordError("Please enter your password");
      return;
    }

    if (isPasswordLogin && password.length < 6) {
      setPasswordError("Password must be at least 6 characters");
      return;
    }

    setIsLoggingIn(true);

    if (isPasswordLogin) {
      const response = await Firebase.loginWithEmailAndPassword({
        email,
        password,
        partnerId: partner?.id,
      });
      if (response?.error) {
        setIsLoggingIn(false);
        setPasswordError(response.error);
        return;
      }
    } else {
      await Firebase.sendSignInLink({ email, partnerId: partner?.id });
      setEmailSent(true);
      setIsLoggingIn(false);
    }
  }, [
    partner,
    email,
    isPasswordLogin,
    isDemoApp,
    isPartnerApp,
    requirePartnerEmailValidation,
    password,
    handleError,
  ]);

  const handleSendPasswordResetEmail = useCallback(async () => {
    if (!email) {
      handleError("Please enter your email");
      return;
    }

    if (!validator.isEmail(email)) {
      setEmailError("Please enter a valid email");
      return;
    }

    await Firebase.sendPasswordResetEmail(email);
    setEmailSent(true);
    Analytics.click({
      action: "Send password reset email",
      event: {
        email,
      },
    });
  }, [email, handleError]);

  const renderWatchAdvizersHero = useCallback(() => {
    if (!isGeneralLogin) return null;
    return (
      <Stack w="100%" gap={0}>
        <Title order={1} c="text.9">
          Log in or create your account
        </Title>
      </Stack>
    );
  }, [isGeneralLogin]);

  const renderHeaderText = useCallback(() => {
    if (isGeneralLogin) {
      if (isPasswordResetView) {
        return (
          <Stack w="100%" gap="xs">
            <Title order={1} c="text.9">
              Reset your password
            </Title>
            <Space h="sm" />
          </Stack>
        );
      }
      return (
        <Stack w="100%" gap="xs">
          {isPasswordLogin ? (
            renderWatchAdvizersHero()
          ) : (
            <Title order={1} size="h1" c="text.8">
              Sign in with a magic link
            </Title>
          )}
          {!isPasswordResetView ? (
            <Title order={2} size="h4" fw={500} c="text.7">
              {isPartnerApp
                ? "We'll create an account if you don't have one yet - it's free."
                : "We'll create an account if you don't have one yet - it's free."}
            </Title>
          ) : null}
          {isPasswordLogin ? <Space h="xl" /> : <Space h="sm" />}
        </Stack>
      );
    }

    return (
      <>
        {renderWatchAdvizersHero()}
        <Space h="xs" />
      </>
    );
  }, [
    isGeneralLogin,
    isPartnerApp,
    isPasswordLogin,
    isPasswordResetView,
    renderWatchAdvizersHero,
  ]);

  const renderTextInput = useCallback(() => {
    return (
      <TextInput
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !isPasswordResetView) {
            e.preventDefault();
            handleSubmit();
          }
        }}
        ta="left"
        label={"Enter your school/work email"}
        placeholder={
          isDemoApp ? "student@myorganization.edu" : "khaleesi@dragonstone.edu"
        }
        error={emailError}
        w="100%"
        size="md"
        labelProps={{
          size: "md",
          fw: 800,
          c: "text.8",
          mb: 4,
          pl: 4,
        }}
      />
    );
  }, [email, emailError, handleSubmit, isDemoApp, isPasswordResetView]);

  const renderPasswordInput = useCallback(() => {
    return (
      <PasswordInput
        w="100%"
        size="md"
        ta="left"
        value={password}
        label={
          <span>
            Enter your password{" "}
            <span style={{ opacity: 0.8, fontStyle: "" }}>(or create one)</span>
          </span>
        }
        placeholder="********"
        error={passwordError}
        onChange={(e) => setPassword(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            handleSubmit();
          }
        }}
        labelProps={{
          size: "md",
          fw: 800,
          c: "text.8",
          mb: 4,
          pl: 4,
        }}
      />
    );
  }, [password, handleSubmit, passwordError]);

  const renderLoginOptions = useCallback(
    (props?: { noGoogle?: boolean }) => {
      const { noGoogle } = props || {};
      if (isPasswordLogin) {
        return (
          <>
            {" "}
            <Space h="sm" />
            {renderTextInput()}
            <Space h="lg" />
            {renderPasswordInput()}
            <Space h="md" />
            <Button
              variant="filled"
              radius="xl"
              size="lg"
              w="100%"
              onClick={handleSubmit}
              loading={isLoggingIn}
            >
              Login{" "}
            </Button>{" "}
            {noGoogle || !isPasswordLogin ? null : (
              <>
                <Space h="lg" />
                <Text size="md" c="text.7">
                  or
                </Text>
                <Space h="lg" />
                <GoogleAuthButton />
              </>
            )}
            <Space h="xl" />
            <Group gap={0}>
              <Text size="sm" c="text.8">
                Want to sign in with a magic link?
              </Text>
              <Button
                variant="transparent"
                size="sm"
                c="primary.7"
                px={4}
                style={{ textDecoration: "underline", fontWeight: 500 }}
                onClick={(event) => {
                  setIsPasswordLogin(false);
                  Analytics.click({
                    action: "Login with magic link",
                    event,
                  });
                }}
              >
                Click here
              </Button>
            </Group>
            <Group gap={0}>
              <Text size="sm" c="text.8">
                Forgot your password?
              </Text>
              <Button
                variant="transparent"
                size="sm"
                c="primary.7"
                px={4}
                style={{ textDecoration: "underline", fontWeight: 500 }}
                onClick={(event) => {
                  setIsPasswordLogin(false);
                  setIsPasswordResetView(true);
                  Analytics.click({
                    action: "Start reset password",
                    event,
                  });
                }}
              >
                Click to reset password
              </Button>
            </Group>
          </>
        );
      }

      if (isPasswordResetView) {
        return (
          <>
            <Space h="sm" />
            {renderTextInput()}
            <Space h="sm" />
            <Button
              variant="filled"
              radius="xl"
              size="lg"
              w="100%"
              leftSection={<IconMail />}
              onClick={handleSendPasswordResetEmail}
            >
              Send password reset email
            </Button>

            <Space h="sm" />

            <Button
              variant="transparent"
              size="sm"
              c="primary.7"
              px={4}
              style={{ textDecoration: "underline", fontWeight: 500 }}
              onClick={(event) => {
                setIsPasswordResetView(false);
                setIsPasswordLogin(true);
                Analytics.click({
                  action: "Back to login",
                  event,
                });
              }}
            >
              Back to login
            </Button>
          </>
        );
      }

      return (
        <>
          <Space h="sm" />

          <Stack w="100%">
            {renderTextInput()}
            <Button
              variant="filled"
              radius="xl"
              size="lg"
              w="100%"
              leftSection={<IconLink />}
              onClick={handleSubmit}
            >
              Get a magic link in your inbox
            </Button>{" "}
          </Stack>
          {noGoogle || !isPasswordLogin ? null : (
            <>
              <Space h="lg" />
              <Text size="md" c="text.4">
                or
              </Text>
              <Space h="lg" />
              <GoogleAuthButton />
            </>
          )}
          <Space h="xl" />
          <Group gap={0}>
            <Text size="md" c="text.6">
              Want to sign in with a password?
            </Text>
            <Button
              variant="transparent"
              size="md"
              c="primary.5"
              px={4}
              style={{ textDecoration: "underline", fontWeight: 500 }}
              onClick={(event) => {
                setIsPasswordLogin(true);
                Analytics.click({
                  action: "Login with password",
                  event,
                });
              }}
            >
              Click here
            </Button>
          </Group>
        </>
      );
    },
    [
      handleSendPasswordResetEmail,
      handleSubmit,
      isLoggingIn,
      isPasswordLogin,
      isPasswordResetView,
      renderPasswordInput,
      renderTextInput,
    ],
  );

  // const renderChooseLoginDefault = useCallback(() => {
  //   return (
  //     <Stack w="100%" gap="md" maw={375}>
  //       {isRestrictedApp && (
  //         <>
  //           <Alert
  //             color="orange"
  //             icon={<IconInfoCircle />}
  //             title="Just a sec!"
  //             ta="left"
  //           >
  //             Please create a free account to keep watching videos.
  //           </Alert>
  //           <Space h="sm" />
  //         </>
  //       )}
  //       <Title order={1} c="text.9">
  //         Are you a student?
  //       </Title>
  //       <Space h="sm" />
  //       <Button
  //         fullWidth
  //         size="md"
  //         to="/login/partners"
  //         radius="xl"
  //         color="primary"
  //       >
  //         Yep, I'll log in with my school email
  //       </Button>
  //       <Button
  //         to="/login/general"
  //         fullWidth
  //         size="md"
  //         variant="outline"
  //         radius="xl"
  //         color="primary"
  //       >
  //         Naw, I'm not a student
  //       </Button>
  //       <Button
  //         fullWidth
  //         size="md"
  //         variant="light"
  //         to="/login/partners"
  //         radius="xl"
  //         color="primary"
  //       >
  //         Hmmm, I'm not sure
  //       </Button>
  //     </Stack>
  //   );
  // }, [isRestrictedApp]);

  const renderTerms = useCallback(() => {
    if (isPartnerSelection) return null;
    return <TermsAndConditions />;
  }, [isPartnerSelection]);

  const renderNoPartnerLoginLink = useCallback(() => {
    // if (isPartnerApp && config.isProductionClient) return null;
    return (
      <Group gap={0} justify="center">
        <Text size="md">
          <Link to="/login/general">
            Don't see your school or org? Click here to log in.
          </Link>
        </Text>
      </Group>
    );
  }, []);

  const renderPartnerSelection = useCallback(() => {
    return (
      <Stack w="100%" gap="xs">
        {!showPlaylistHeader ? <Space h="10vh" /> : null}
        <Title order={1} c="text.9" id="select-partner-title">
          {isAssignmentPage
            ? "Log in to start your assignment"
            : "Choose your Advize partner"}
        </Title>
        {renderNoPartnerLoginLink()}
        <Space h="sm" />
        <PartnerSelector labelId="select-partner-title" />
        <Space h="sm" />
        {renderNoPartnerLoginLink()}
      </Stack>
    );
  }, [isAssignmentPage, renderNoPartnerLoginLink, showPlaylistHeader]);

  const renderPartnerLoginHeader = useCallback(() => {
    return (
      <Stack w="100%" gap={0} align="center">
        {isDemoApp ? (
          <Stack
            w={300}
            h={300 * (9 / 16)}
            align="center"
            justify="center"
            bg={theme.colors.secondary[0]}
            style={{
              border: `1px solid ${theme.colors.border[3]}`,
              borderRadius: 6,
            }}
          >
            <IconPhotoPlus size={64} color={theme.colors.secondary[7]} />
            <Text titleStyle="h5" c="secondary.8">
              Your organization's logo here
            </Text>
          </Stack>
        ) : (
          <Image
            src={partner?.logoURL}
            alt={partner?.title}
            w={300}
            mah={300}
            ratio={16 / 9}
            fit={
              partner?.title.includes("Knauss") ||
              partner?.title.includes("Stanford") ||
              partner?.title.includes("Eller")
                ? "contain"
                : "cover"
            }
            {...partner?.styles?.loginHeaderImageProps}
          />
        )}

        {!isDemoApp ? null : <Space h="sm" />}

        {!isPasswordResetView ? (
          <Title order={2} size="h4" fw={500} c="primary.7" mt="md">
            We'll create an account if you don't have one yet!
          </Title>
        ) : null}
      </Stack>
    );
  }, [
    isDemoApp,
    isPasswordResetView,
    partner?.logoURL,
    partner?.styles?.loginHeaderImageProps,
    partner?.title,
    theme.colors.border,
    theme.colors.secondary,
  ]);

  const renderPartnerLogin = useCallback(() => {
    if (!partner) return null;
    return (
      <Stack gap={0} w="100%" align="center">
        <Space h="10vh" />
        {renderPartnerLoginHeader()}
        <Space h="md" />
        {renderLoginOptions({ noGoogle: true })}
      </Stack>
    );
  }, [partner, renderLoginOptions, renderPartnerLoginHeader]);

  const renderDemoLogin = useCallback(() => {
    return (
      <Stack gap={0} w="100%" align="center">
        <Space h="10vh" />
        {renderPartnerLoginHeader()}
        <Space h="md" />
        {renderLoginOptions({ noGoogle: true })}
      </Stack>
    );
  }, [renderLoginOptions, renderPartnerLoginHeader]);

  const renderContent = useCallback(() => {
    if (isDemoApp) {
      return renderDemoLogin();
    }

    if (partner) {
      return renderPartnerLogin();
    }

    if (isPartnerSelection) {
      return renderPartnerSelection();
    }

    if (isGeneralLogin) {
      return renderLoginOptions();
    }

    // return renderChooseLoginDefault();
    return renderPartnerSelection();
  }, [
    isDemoApp,
    partner,
    isPartnerSelection,
    isGeneralLogin,
    renderPartnerSelection,
    renderDemoLogin,
    renderPartnerLogin,
    renderLoginOptions,
  ]);

  const CoreContent = useMemo(() => {
    return (
      <Stack
        w="100%"
        maw={isPartnerSelection ? 550 : 450}
        gap={0}
        align="center"
      >
        {isPartnerApp && isGeneralLogin ? <Space h="10vh" /> : null}
        {renderHeaderText()}
        {renderContent()}
        <Space h="xl" />
        {renderTerms()}
      </Stack>
    );
  }, [
    isGeneralLogin,
    isPartnerApp,
    isPartnerSelection,
    renderContent,
    renderHeaderText,
    renderTerms,
  ]);

  if (emailSent) {
    return (
      <Stack
        align="center"
        justify="center"
        h="100%"
        mih="100vh"
        ta="center"
        gap={0}
        p="sm"
        maw={500}
        mx="auto"
      >
        <Group w="100%" align="center" justify="center">
          <IconBrandTelegram size={64} color={theme.colors.text[6]} />
        </Group>
        <Space h="lg" />
        <Title order={1} lh={1} fz={isDesktop ? 48 : 40} c="text.8">
          Check your inbox (and spam folder)!
        </Title>
        <Space h="xs" />
        <Text size="lg" c="text.6">
          We've sent you a{" "}
          {isPasswordResetView ? "password reset email" : "magic link"} to{" "}
          {email || "your email"}. If you don't see it, check your spam folder
          or contact support (dev@advizehub.com).
        </Text>
      </Stack>
    );
  }

  if (showPlaylistHeader) {
    return <Playlist isExplicitChildren>{CoreContent}</Playlist>;
  }

  return (
    <Stack
      align="center"
      // justify={isPartnerSelection ? "flex-start" : "center"}
      bg={theme?.colors?.loginBackground?.[0] || theme.colors.background[0]}
      // h="100%"
      mih="100vh"
      h="auto"
      ta="center"
      gap={0}
      p="sm"
      pt={(isPartnerSelection || isGeneralLogin) && !isDemoApp ? 60 : 36}
      pb={100}
      w="100%"
      mx="auto"
    >
      {CoreContent}
    </Stack>
  );

  // return (
  //   <Stack
  //     align="center"
  //     justify={isPartnerSelection ? "flex-start" : "center"}
  //     bg={theme?.colors?.loginBackground?.[0] || theme.colors.background[0]}
  //     // h="100%"
  //     mih="100vh"
  //     ta="center"
  //     gap={0}
  //     p="sm"
  //     pt={isPartnerSelection || isGeneralLogin ? 60 : 36}
  //     pb={100}
  //     w="100%"
  //     mx="auto"
  //   >
  //     <Stack
  //       w="100%"
  //       maw={isPartnerSelection ? 550 : 450}
  //       gap={0}
  //       align="center"
  //     >
  //       {renderHeaderText()}
  //       {renderContent()}
  //       <Space h="xl" />
  //       {renderTerms()}
  //     </Stack>
  //   </Stack>
  // );
};
